export const remToPixel = (rem) => {
  const rootFontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize);
  const pixels = rem * rootFontSize;
  return pixels;
};

export const createDebouncer = (wait) => (fn) => {
  let i = 0;
  return (...args) => {
    const currentI = ++i;
    wait(() => {
      if (currentI === i) {
        fn(...args);
      }
    });
  };
};

// https://stackoverflow.com/questions/8495687/split-array-into-chunks#comment84212474_8495740
export const arrayChunk = (array, chunkSize) => {
  return Array(Math.ceil(array.length / chunkSize))
    .fill()
    .map((_, index) => index * chunkSize)
    .map((begin) => array.slice(begin, begin + chunkSize));
};

export const request = async (url, params) => {
  const res = await fetch(url, params);
  if (!res.ok) {
    const responseError = await res.json();
    console.error(`NETWORK RESPONSE ERROR -- ${responseError.status}: `, responseError);
    throw responseError;
  }

  return res.json();
};

export const convertToCamelCase = (string) => {
  if (!string) {
    return '';
  }

  return string
    .replace(/.\b(?<word>\w)/g, (_, $1) => {
      return $1.toUpperCase();
    })
    .replace(/[\s:'"]/g, '')
    .replace(/^(?<rest>.)/u, (_, $1) => {
      return $1.toLowerCase();
    });
};

// https://github.com/sindresorhus/p-defer/blob/0abf7f56337a450cbff45074dd8c83f8ace4726c/index.js
export const pDefer = () => {
  const deferred = {};

  deferred.promise = new Promise((resolve, reject) => {
    deferred.resolve = resolve;
    deferred.reject = reject;
  });

  return deferred;
};

export const sortAlpha = (arry, key) => {
  return arry.sort((a, b) => {
    if (a[key] < b[key]) {
      return -1;
    }
    if (a[key] > b[key]) {
      return 1;
    }
    return 0;
  });
};
